import { render } from "./View.vue?vue&type=template&id=1cf7c297&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import "./View.vue?vue&type=style&index=0&id=1cf7c297&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf7c297"]])

export default __exports__